<template>
    <span>
        <el-select v-model="selectValue" multiple placeholder="请选择">
        <el-option
                v-for="item in roles"
                :key="item.code"
                :label="item.name"
                :value="item.code">
        </el-option>
    </el-select>
        <input v-model="value" style="display: none" />
    </span>
</template>

<script>
    export default {
        name: "RoleSelect",
        props:{
            value: {
                type: Array,
                default:function () {
                    return [] ;
                }
            }
        },
        watch:{
            value:{
              deep:true,
              handler:function () {
                  this.selectValue = this.value;
              }
            },
            selectValue:{
                deep:true,
                handler:function () {
                    this.$emit('input',this.selectValue);
                }
            }
        },
        data(){
            return {
                roles:[],
                selectValue:[],
            }
        },
        created() {

            let vm = this;

            vm.$http.post(vm.$api.role.list,vm.$qs.stringify({onPage:false})).then((resp)=>{
                    vm.roles = resp.data.data.roles;
            });

        }
    }
</script>

<style scoped>

</style>